import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tabs as CoreTabs } from '@vds-core/tabs';
import { TitleConfig, TypographyConfig } from '@vds/typography';
import { colors } from '@vds/theme';
import { TextLinkCaret } from '@vds/buttons';
var propTypes = {
  /**
   * Determines the layout of the Tabs, defaults to horizontal
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * Width of all Tabs when orientation is vertical, defaults to 25%.
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Tabs will be displayed in inverted colors if inverted prop is passed.
   */
  inverted: PropTypes.bool
};
var defaultProps = {
  orientation: 'horizontal',
  width: '25%'
};
var typescale = TypographyConfig.getTypescale();

var Tabs = function Tabs(props) {
  var orientation = props.orientation;
  return /*#__PURE__*/React.createElement(CoreTabs, _extends({}, props, {
    focusState: true,
    minHeight: true,
    colorConfig: colors,
    titleConfig: TitleConfig,
    typescale: typescale,
    TextLinkCaret: TextLinkCaret,
    orientation: orientation
  }));
};

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
export default Tabs;